import { GridColDef } from '@microservices/wiskey-react-table-component'
import { IncidentReport } from '@mobileTypes'
import { Chip } from '@mui/material'

export const REPORTS_PAGE_SIZE = 50
export const REPORTS_TTL_DAYS_FALLBACK = 3

export const formatReportDateTime = (iso: string): string => {
  const date = new Date(iso)

  if (Number.isNaN(date.getTime())) {
    return iso
  }

  return date.toLocaleString()
}

export const formatReportDeletesAt = (archivedAt: string, ttlDays: number): string => {
  const date = new Date(archivedAt)

  if (Number.isNaN(date.getTime())) {
    return archivedAt
  }

  date.setDate(date.getDate() + ttlDays)

  return date.toLocaleString()
}

export const MOBILE_REPORTS_ARCHIVE_COLUMNS: GridColDef[] = [
  {
    field: 'archivedAt',
    headerName: 'Archived',
    width: 180,
    renderCell: params => {
      const archivedAt = (params.row as IncidentReport).archivedAt

      return archivedAt ? formatReportDateTime(archivedAt) : '—'
    },
  },
]

export const MOBILE_REPORTS_COLUMNS: GridColDef[] = [
  {
    field: 'occurredAt',
    headerName: 'Time',
    width: 180,
    renderCell: params => formatReportDateTime((params.row as IncidentReport).occurredAt),
  },
  {
    field: 'app',
    headerName: 'App',
    width: 180,
    renderCell: params => {
      const app = (params.row as IncidentReport).app

      return app ? `${app.configId} ${app.configVersion}`.trim() || '—' : '—'
    },
  },
  {
    field: 'triggerKind',
    headerName: 'Trigger',
    width: 120,
    renderCell: params => (params.row as IncidentReport).trigger.kind,
  },
  {
    field: 'message',
    headerName: 'Message',
    flex: 1,
    minWidth: 220,
    renderCell: params => (params.row as IncidentReport).trigger.message,
  },
  {
    field: 'os',
    headerName: 'OS',
    width: 140,
    renderCell: params => {
      const report = params.row as IncidentReport

      return <Chip label={`${report.device.os} ${report.device.osVersion}`} size='small' />
    },
  },
]
